import { createSelector } from 'reselect';

const storeMentors = (store, props) => store.companiesMentors.mentors;

export const getMentors = createSelector(storeMentors, mentors =>
  Object.keys(mentors).map(key => mentors[key])
);



// WEBPACK FOOTER //
// ./src/selectors/mentors.js